module.exports = __webpack_public_path__ + "static/media/wificall.92aa83c6.png";